import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import {
    MAIN_DOMAIN,
    EXTRA_EXERCISE,
    COMMENTS,
    DECREASE_OPERATION,
    INCREASE_OPERATION,
    TYPE_TRANSACTION
} from '@app/app.constants';

import { declensionOfNumerals } from '@app/_utils/helpers';
import { Pupil, ExExercise, Currency, Lesson } from '@df/interfaces';
import { TaskService } from '@app/core/services/task.service';
import {} from '@app/app.constants';

import { closeIcon } from '@app/app.constants';

@Component({
    selector: 'app-ex-exercise-modal',
    templateUrl: './ex-exercise-modal.component.html',
    styleUrls: ['./ex-exercise-modal.component.scss']
})
export class ExExerciseModalComponent implements OnInit, OnDestroy {
    @Input() modalRef: BsModalRef;
    @Input() exExercise: ExExercise;
    @Input() pupil: Pupil;
    @Input() currentLesson: Lesson;
    @Input() availableCardId: number;
    @Output() closeModal = new EventEmitter<any>();
    @Output() clearCardNumber = new EventEmitter<any>();

    extraExercise = EXTRA_EXERCISE;
    typeTransaction = TYPE_TRANSACTION;
    MAIN_DOMAIN = MAIN_DOMAIN;
    currencies: Currency[] = [];
    currentCurrency: Currency;
    closeIcon = closeIcon;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private taskService: TaskService) {}

    public ngOnInit(): void {
        this.getCurrencyForLesson(this.currentLesson);
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    public close(): void {
        this.closeModal.emit();
    }

    public onSubmit(isCorrect: boolean, transaction_type = ''): void {
        this.close();

        if (isCorrect) {
            if (transaction_type === this.typeTransaction.TRANSACTION_TYPE_CASH) {
                this.taskService
                    .moneyOperation(
                        this.pupil.id,
                        this.exExercise.reward,
                        INCREASE_OPERATION,
                        COMMENTS.EX_EXERCISE_REWARD,
                        this.availableCardId
                    )
                    .subscribe(() => {
                        this.taskService
                            .moneyOperation(
                                this.pupil.id,
                                this.exExercise.reward,
                                DECREASE_OPERATION,
                                COMMENTS.EX_EXERCISE_REWARD,
                                this.availableCardId
                            )
                            .pipe(takeUntil(this.destroy$))
                            .subscribe();
                    });
            }

            if (transaction_type === this.typeTransaction.TRANSACTION_TYPE_BANK) {
                this.taskService
                    .moneyOperation(
                        this.pupil.id,
                        this.exExercise.reward,
                        INCREASE_OPERATION,
                        COMMENTS.EX_EXERCISE_REWARD,
                        this.availableCardId
                    )
                    .pipe(takeUntil(this.destroy$))
                    .subscribe();
            }
            this.updateCardResult(this.availableCardId, this.extraExercise.SOLVED_CORRECT);
        } else {
            this.updateCardResult(this.availableCardId, this.extraExercise.SOLVED_INCORRECT);
        }
    }

    private getCurrencyForLesson(lesson): void {
        this.taskService
            .getCurrencyForLesson(lesson)
            .pipe(takeUntil(this.destroy$))
            .subscribe(response => {
                if (response.count !== 0) {
                    this.currencies = response.results;
                    this.currentCurrency = this.currencies[0];
                }
            });
    }

    declensionOfNumerals(amount: number): string {
        return declensionOfNumerals(amount, this.currentCurrency);
    }

    updateCardResult(cardId, isExtraExercise) {
        this.taskService
            .updateCardResult(cardId, isExtraExercise)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.clearCardNumber.emit();
            });
    }
}
